// @flow
import type { Region } from 'digicel-kaizen-library';

import type { SignUpRegionActionType } from './actions';

export const initialState: RegionStateType = null;

export default (state: RegionStateType = initialState, action: SignUpRegionActionType): RegionStateType => {
  switch (action.type) {
    case 'SIGNUP_SET_REGION':
      return action.payload.region;
    default:
      return state;
  }
};

export type RegionStateType = ?Region;
